<template>
    <div class="tax">
        <PageTitle icon="fa fa-clone" main="Registro" sub="Imposto" />
         <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="tax-id" type="hidden" v-model="tax.id" />
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Nome:" 
                        label-for="tax-name_tax">
                        <b-form-input 
                            id="tax-name_tax" 
                            type="text" 
                            ref="searchFocus"
                            v-model="tax.name_tax" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Nome..." />
                    </b-form-group>
                </b-col> 
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" v-model="tax.blocked" true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tax-blocked"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="tax-blocked">
                                Bloqueado?
                            </label>
                        </div>
                    </div>
                </b-col>                    
             </b-row>
             <b-row>
                  <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                            v-model="tax.payment" 
                            true-value="1" 
                            false-value="0" 
                            type="checkbox" 
                            id="tax-payment"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="tax-payment">
                            Pagamento?
                        </label>
                        </div>
                    </div>
                </b-col> 
                 <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                            v-model="tax.receipt" 
                            true-value="1" 
                            false-value="0" 
                            type="checkbox" 
                            id="tax-receipt"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="tax-receipt">
                            Recebimento?
                        </label>
                        </div>
                    </div>
                </b-col> 
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                        <input class="form-check-input" 
                            v-model="tax.devolution" 
                            true-value="1" 
                            false-value="0" 
                            type="checkbox" 
                            id="tax-devolution"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="tax-devolution">
                            Devolução?
                        </label>
                        </div>
                    </div>
                </b-col> 
             </b-row>
             <b-row>
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="tax.log_book" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="tax-log_book"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="tax-log_book">
                                Livro Fiscal?
                            </label>
                        </div>
                    </div>
                </b-col>  
                <b-col md="3" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input 
                                class="form-check-input" 
                                v-model="tax.account" 
                                true-value="1" 
                                false-value="0" 
                                type="checkbox" 
                                id="tax-account"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="tax-account">
                                Contabiliza?
                            </label>
                        </div>
                    </div>
                </b-col>  
            </b-row>
            <b-row>
                <b-col md="6" sm="12">
                        <b-form-group 
                        label="Tipo de Imposto:" label-for="tax-type_tax_id">
                        <b-form-select id="tax-type_tax_id"
                        :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                        size="sm"
                        :options="typetaxs" v-model="tax.type_tax_id" />
                        </b-form-group>
                </b-col>  
            </b-row>
            <b-row>
                <b-col md="2" sm="12">
                    <b-form-group 
                    label="Operação:" label-for="tax-operation_id">
                    <b-form-select id="tax-operation_id"
                    @input="loadOperationsLevelOnes"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    :options="operations" v-model="tax.operation_id" />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group 
                    label="1º Nível:" label-for="tax-operation_level_one_id">
                    <b-form-select id="tax-operation_level_one_id"
                    @input="loadOperationsLevelTwos"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    :options="operationslevelones" v-model="tax.operation_level_one_id" />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <b-form-group 
                    label="2º Nível:" label-for="tax-operation_level_two_id">
                    <b-form-select id="tax-operation_level_two_id"
                    :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    :options="operationsleveltwos" v-model="tax.operation_level_two_id" />
                    </b-form-group>
                </b-col>
            </b-row>
         </b-form>
          <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12" class="sub-background">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                         
                        size="sm" 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                        </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                         :class="icon" 
                         @click="[loadTaxs(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
           <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            ref="searchFocus"
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Informe a descrição" 
                            class="form-control">
                    </div>
                </div>
         <transition  name="slide" type="animation" appear>       
         <b-table 
            :busy="isBusy" 
            class="table-responsive" 
            :per-page="perPage" 
            :current-page="currentPage" 
            v-show="showTable" 
            hover 
            key="slide" 
             head-variant="light" 
            :items="filteredList" 
            :fields="fields">
            <template v-slot:table-busy>
                <div class="text-center text-info my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Carregando...</strong>
                </div>
            </template>
               <template v-slot:cell(actions)="data">
                    <b-button  
                        title = "Detalhe do registro" 
                        size="sm" 
                        variant="light"
                         @click="loadTax(data.item, 'read')" 
                         class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Editar registro" 
                        size="sm" variant="light"
                         @click="loadTax(data.item)"
                          class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                    <b-button  
                        title = "Excluir registro" 
                        size="sm" 
                        variant="light" 
                        @click="loadTax(data.item, 'remove')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>   
         </b-table>    
         </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition> 
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

export default {
    name: 'Tax',
    components: {PageTitle},
    data: function() {
        return {
            mode: 'insert',
            search: '',
            tax:{},
            taxs: [],
            typetaxs: [],
            accountplans: [],
            historicalstandards: [],
            operationsleveltwos: [],
            operationslevelones: [],
            operations:[],
            showTable: false,
            isBusy: false,
            currentPage: 1,
            perPage: 5,
            fields: [
                { key: 'name_tax', label: 'Nome', sortable: true},
                { key: 'payment', label: 'Pagamento', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },     
                { key: 'receipt', label: 'Recebimento', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },            
                { key: 'blocked', label: 'Bloqueado', sortable: false,
                        formatter: value => value ? 'Sim' : 'Não' },               
                { key: 'actions', label: 'Ações' }
            ]
        }
    },
     computed: {
        filteredList() {
        return this.taxs.filter(tax => {
        return tax.name_tax.toLowerCase().includes(this.search.toLowerCase())
            })
        },
        icon() {
            return this.showTable ? "fa-retweet" : "fa-search"
        },
        rows() {
            return this.taxs.length
        },
    },
    methods: {
        loadTaxs() {
            const url = `${baseApiUrl}/taxs`
            axios.get(url).then(res => {
                this.taxs = res.data
                 this.isBusy = false
            })
        },
        reset() {
            this.mode = 'insert'
            this.loadTaxs()
        },
        toggleBusy() {
          this.isBusy = !this.isBusy
        },
        alterModo() {
                    this.mode = 'save'
                    this.$refs.searchFocus.focus();
                    this.tax = {}
                   
            }, 
        async save() {
            const method = this.tax.id ? 'put' : 'post'
            const id = this.tax.id ? `/${this.tax.id}` : ''
            await axios[method](`${baseApiUrl}/taxs${id}`, this.tax)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
       async remove() {
            const id = this.tax.id
            await axios.delete(`${baseApiUrl}/taxs/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
       async loadTypetax() {
            const url = `${baseApiUrl}/typetaxs`
            await axios.get(url).then(res => {
                   this.typetaxs = res.data.map(typetax => {
                    return { value: typetax.id, text: typetax.name_type_tax }
                    })
                })
        },
        async loadOperation() {
            const url = `${baseApiUrl}/operations`
            await axios.get(url).then(res => {
                   this.operations = res.data.map(operation => {
                    return { value: operation.id, text: operation.name_operation }
                    })
                })
        },
        async loadOperationsLevelOnes() {
            const url = `${baseApiUrl}/operationslevelones/${this.tax.operation_id}/operations`
            await axios.get(url).then(res => {
               this.operationslevelones = res.data.map(operationslevelone => {
                    return { value: operationslevelone.id, text: operationslevelone.name_operation_level_one }
                    })
            })
        },
        async loadOperationsLevelTwos() {
            const url = `${baseApiUrl}/operationsleveltwos/${this.tax.operation_level_one_id}/operationslevelones`
            await axios.get(url).then(res => {
                 this.operationsleveltwos = res.data.map(operationsleveltwo => {
                    return { value: operationsleveltwo.id, text: operationsleveltwo.name_operation_level_two }
                    })
            })
        },
        loadTax(tax, mode = 'save') {
            this.$refs.searchFocus.focus();
            this.mode = mode
            this.tax = { ...tax }

        }
    },
    mounted() {
       this.loadTypetax()
       this.loadOperation()
       this.loadTaxs()
       this.showTable = true
    }
}
</script>

<style>

    .sub-background{
      background:linear-gradient(to top, #bdc3c7, #e7ebee);
      border-radius: 35px ;
    }

    .tax {
        font-size: 0.7rem;
    }


    .tax input,label,form{
        font-size: 0.7rem;
    }
    .tax button{
        font-size: 0.7rem;
    }

    .tax select{
        font-size: 0.7rem;
    }

    .tax table{
        font-size: 0.7rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
